import { render } from "./Loader.vue?vue&type=template&id=b7e20bcc&scoped=true&ts=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=b7e20bcc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e20bcc"]])